// Externe Bibliotheken
import React, { Component } from 'react';

// Styles
import './paymentRefund.scss';

const params = {
    iLayer: {
        directDebit: {
            holder: 'Bitte achten Sie darauf, dass der Kontoinhaber mit den bei Ihrer Bank eingetragenen Kontoinformationen übereinstimmt.',
            IBAN: 'Geben Sie bitte die IBAN des Kontos an, auf das die Erstattung erfolgen soll.<br>Die International Bank Account Number ist eine international standardisierte Nummer, welche jedes Girokonto in einem der an diesem System teilnehmenden Länder eindeutig bezeichnet und definiert.<br><br>Die IBAN (internationale Bankkontonummer) startet mit dem Länderkürzel DE gefolgt von einer 2-stelligen Prüfziffer, der 8-stelligen Bankleitzahl und Ihrer 10-stelligen Kontonummer. Sie finden die IBAN z.B. auf Ihrem Kontoauszug oder auf der Webseite Ihrer Bank. Achten Sie auf Zahlendreher und Tippfehler!',
        },
    },
    errorWording: {
        directDebit: {
            holder: {
                default: 'Bitte geben Sie einen Inhaber ein.',
                invalid: 'Bitte geben Sie einen gültigen Inhaber ein.',
            },
            IBAN: {
                default: 'Bitte geben Sie Ihre IBAN ein.',
                invalid: 'Die eingegebene IBAN ist ungültig.',
            },
            BIC: {
                default: 'Der geben Sie Ihre BIC ein.',
                invalid: 'Der eingegebene BIC ist ungültig.',
            },
        },
    },
};

class PaymentRefund extends Component {
    constructor(props) {
        super(props);

        // init focus input trigger
        this['directDebit-holder'] = React.createRef();
        this.IBAN = React.createRef();

        this.state = {
            paymentTypes: {
                directDebit: {
                    title: 'Lastschrift',
                },
            },
            'directDebit-holder': '',
            IBAN: '',
            refund: {
                selected: 'directDebit',
                valid: false,
                data: {},
            },
            unsetPaymentTypes: {},
            directDebit: {
                placeholder_BIC: 'BIC',
            },
            formErrors: {
                directDebit: {
                    holder: params.errorWording.directDebit.holder.default,
                    IBAN: params.errorWording.directDebit.IBAN.default,
                    BIC: params.errorWording.directDebit.BIC.default,
                },
            },
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.getCurrentPaymentData = this.getCurrentPaymentData.bind(this);
    }

    componentDidMount() {
        this.getCurrentPaymentData(this.props.currentPaymentData);

        if (this.props.paymenttypes !== undefined) {
            this.setState({
                unsetPaymentTypes: this.props.paymenttypes,
            });
        }
    }

    getCurrentPaymentData(currentPaymentData) {
        if (currentPaymentData !== undefined) {
            this.setState({
                currentPaymentData: currentPaymentData,
            });

            this.setState({
                defaultPayment: currentPaymentData.type,
            });
        }
    }

    iLayer(t, c) {
        let getILayerInformations = params.iLayer[t];

        if (getILayerInformations !== undefined && getILayerInformations[c] !== undefined) {
            return (
                <div className="info-layer">
                    <i className="material-icons">info</i>
                    <div className="overlay">
                        <div className="corner"></div>
                        <div className="content">
                            <p dangerouslySetInnerHTML={{ __html: getILayerInformations[c] }}></p>
                        </div>
                    </div>
                </div>
            );
        }
    }

    refundForm() {
        const $refundFrom = [];

        $refundFrom.push(
            <div className="refund-content" key="">
                <h3 className="heading">Bankdaten</h3>
                {this.state.refund.selected === 'directDebit' && (
                    <div className="refund-form directDebit">
                        <div className="row">
                            <div className="first">
                                <label htmlFor="directDebit-holder">Kontoinhaber</label>
                            </div>
                            <div className="last">
                                <input
                                    id="directDebit-holder"
                                    name="directDebit-holder"
                                    ref={this['directDebit-holder']}
                                    value={this.state['directDebit-holder']}
                                    type="text"
                                    placeholder="Kontoinhaber"
                                    onChange={(event) => {
                                        this.handleUserInput(event);
                                    }}
                                />

                                {this.resetTrigger('directDebit-holder')}

                                {this.iLayer('directDebit', 'holder')}
                            </div>

                            {this.props.hasAlreadyTested && this.state.formErrors.directDebit.holder !== true && (
                                <div className="error">{this.state.formErrors.directDebit.holder}</div>
                            )}
                        </div>

                        <div className="row">
                            <div className="first">
                                <label htmlFor="IBAN">IBAN</label>
                            </div>
                            <div className="last">
                                <input
                                    id="IBAN"
                                    name="IBAN"
                                    ref={this.IBAN}
                                    value={this.state.IBAN.toUpperCase()}
                                    type="text"
                                    placeholder="IBAN"
                                    maxLength={27}
                                    onChange={(event) => {
                                        this.handleUserInput(event);
                                        this.format__IBAN(event);
                                    }}
                                />

                                {this.resetTrigger('IBAN')}

                                {this.iLayer('directDebit', 'IBAN')}
                            </div>

                            {this.props.hasAlreadyTested && this.state.formErrors.directDebit.IBAN !== true && (
                                <div className="error">{this.state.formErrors.directDebit.IBAN}</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );

        return $refundFrom;
    }

    handleUserInput(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    }

    resetTrigger(e) {
        if (this.state[e].length) {
            return (
                <div
                    className="reset-trigger"
                    onClick={(event) => {
                        this.setState({ [e]: '' });
                        this.validateField(e, '');
                        this[e].current.focus();
                    }}>
                    <i className="material-icons">clear</i>
                </div>
            );
        }
    }

    validateField(fieldName, value) {
        let $this = this;
        let fieldValidationErrors = this.state.formErrors;

        function directDebit() {
            let valid, errorCase;

            /*
             * Returns 1 if the IBAN is valid
             * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
             * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
             */
            function isValidIBANNumber(input) {
                var CODE_LENGTHS = {
                    AD: 24,
                    AE: 23,
                    AT: 20,
                    AZ: 28,
                    BA: 20,
                    BE: 16,
                    BG: 22,
                    BH: 22,
                    BR: 29,
                    CH: 21,
                    CR: 21,
                    CY: 28,
                    CZ: 24,
                    DE: 22,
                    DK: 18,
                    DO: 28,
                    EE: 20,
                    ES: 24,
                    FI: 18,
                    FO: 18,
                    FR: 27,
                    GB: 22,
                    GI: 23,
                    GL: 18,
                    GR: 27,
                    GT: 28,
                    HR: 21,
                    HU: 28,
                    IE: 22,
                    IL: 23,
                    IS: 26,
                    IT: 27,
                    JO: 30,
                    KW: 30,
                    KZ: 20,
                    LB: 28,
                    LI: 21,
                    LT: 20,
                    LU: 20,
                    LV: 21,
                    MC: 27,
                    MD: 24,
                    ME: 22,
                    MK: 19,
                    MR: 27,
                    MT: 31,
                    MU: 30,
                    NL: 18,
                    NO: 15,
                    PK: 24,
                    PL: 28,
                    PS: 29,
                    PT: 25,
                    QA: 29,
                    RO: 24,
                    RS: 22,
                    SA: 24,
                    SE: 24,
                    SI: 19,
                    SK: 24,
                    SM: 27,
                    TN: 24,
                    TR: 26,
                    AL: 28,
                    BY: 28,
                    EG: 29,
                    GE: 22,
                    IQ: 23,
                    LC: 32,
                    SC: 31,
                    ST: 25,
                    SV: 28,
                    TL: 23,
                    UA: 29,
                    VA: 22,
                    VG: 24,
                    XK: 20,
                };
                var iban = String(input)
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                    digits;
                // check syntax and length
                if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
                    return false;
                }
                // rearrange country code and check digits, and convert chars to ints
                digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
                    return letter.charCodeAt(0) - 55;
                });
                // final check
                return mod97(digits);
            }

            function mod97(string) {
                var checksum = string.slice(0, 2),
                    fragment;
                for (var offset = 2; offset < string.length; offset += 7) {
                    fragment = String(checksum) + string.substring(offset, offset + 7);
                    checksum = parseInt(fragment, 10) % 97;
                }
                return checksum;
            }

            /*
             *  fieldName validation
             */

            switch (fieldName) {
                case 'directDebit-holder':
                    valid = value.length > 0;
                    errorCase = params.errorWording.directDebit.holder.default;

                    if (valid && value.length < 2) {
                        valid = value.length === 2;
                        errorCase = params.errorWording.directDebit.holder.invalid;
                    }

                    fieldValidationErrors.directDebit.holder = valid ? true : errorCase;

                    // set data
                    $this.state.refund.data['accountOwner'] = value;

                    break;
                case 'IBAN':
                    valid = value.length > 1;

                    // set placeholder
                    let ibanDE = /^DE/g,
                        ibanDe = /^De/g;
                    if (ibanDE.test(value) || ibanDe.test(value)) {
                        $this.setState({
                            directDebit: {
                                placeholder_BIC: 'optional',
                            },
                        });
                    } else {
                        $this.setState({
                            directDebit: {
                                placeholder_BIC: 'BIC',
                            },
                        });
                    }

                    errorCase = params.errorWording.directDebit.IBAN.default;

                    if (valid && value.length >= 2) {
                        valid = isValidIBANNumber(value);
                        errorCase = params.errorWording.directDebit.IBAN.invalid;
                    }

                    fieldValidationErrors.directDebit.IBAN = valid ? true : errorCase;

                    // set data
                    $this.state.refund.data['accountNumber'] = value.toUpperCase();
                    break;
                case 'BIC':
                    valid = value.length > 0;
                    errorCase = params.errorWording.directDebit.BIC.default;

                    if (valid && value.length < 3) {
                        valid = value.length === 3;
                        errorCase = params.errorWording.directDebit.BIC.invalid;
                    }

                    fieldValidationErrors.directDebit.BIC = valid ? true : errorCase;
                    break;
                default:
                    break;
            }

            $this.setState({ formErrors: fieldValidationErrors });

            // is valid
            if (fieldValidationErrors.directDebit.IBAN === true && fieldValidationErrors.directDebit.holder === true) {
                $this.state.refund.valid = true;
            } else {
                $this.state.refund.valid = false;
            }
        }

        // set validate type
        switch (this.state.refund.selected) {
            case 'directDebit':
                directDebit();
                break;
            default:
        }

        // return
        let refund = {
            type: this.state.refund.selected,
            valid: this.state.refund.valid,
            data: this.state.refund.data,
        };

        this.props.getPaymentChange(refund);
    }

    format__IBAN(event) {
        let u = event.target.value.toUpperCase();
        let v = u
            .replace(/[^\dA-Z]/g, '')
            .replace(/(.{4})/g, '$1 ')
            .trim();

        return (event.target.value = v);
    }

    render() {
        return (
            <div className="sec refund">
                <p>
                    Bitte füllen Sie das nachfolgende Formular mit einer auf Ihren Namen lautenden Bankverbindung aus.
                    <br />
                    Eine Erstattung führen wir anschließend zeitnah durch.
                </p>

                {this.refundForm()}
            </div>
        );
    }
}

export default PaymentRefund;
